import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar} from '@ionic/react';
import React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import './css/general.css';
import styles from './css/Score.module.css';
import { UserSubject}  from './ScorePage'


interface IndScoreProps extends RouteComponentProps {
  // Define the props here
}
interface IndScoreState {
  // Define the state here
  SelectedSubject : UserSubject;
}

class IndScorePage extends React.Component<IndScoreProps, IndScoreState>{
  constructor(props: IndScoreProps) {
    super(props);

    if(localStorage.getItem("Sub") === null)
    {
      this.props.history.go(-1);
    }

    this.state = {
      SelectedSubject : JSON.parse(localStorage.getItem("Sub") as string),
    }
  }

  render() {
    return (
      <IonPage>
        <IonHeader class="ion-no-border">
          <IonToolbar>
          <button className="backButton" onClick={() => {this.props.history.goBack()}}>&larr;</button>
            <IonTitle>{this.state.SelectedSubject.subjectName}</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent fullscreen>
          <div className={styles.subjects}>
            <div className= {styles.flexDetail}>
              <div className={styles.detailPanel}>
                <h1 className={styles.title}>Aantal voltooide quizzen</h1>
                <p className={styles.detail}>{this.state.SelectedSubject.completedChallenges.length}</p>
              </div>
              <div className={styles.detailPanel}>
                <h1 className={styles.title}>Aantal niet deelgenomen / onvoltooide quizzen</h1>
                <p className={styles.detail}>{this.state.SelectedSubject.notParticipatedChallenges.length} / {this.state.SelectedSubject.notCompletedChallenges.length}</p>
              </div>
            </div>

            <div className= {styles.flexDetail}>
              <div className={styles.detailPanel}>
                <h1 className={styles.title}>Totaal score</h1>
                <p className={styles.detail}>{this.state.SelectedSubject.subjectScore}</p>
              </div>
              <div className={styles.detailPanel}>
                <h1 className={styles.title}>Maximum haalbare score</h1>
                <p className={styles.detail}>{this.state.SelectedSubject.subjectMaxScore}</p>
              </div>
            </div>
          </div>
        </IonContent>
      </IonPage>
    );
  }
};

export default withRouter(IndScorePage)
